import * as React from 'react'
import * as DateFns from 'date-fns'
import * as moment from 'moment'
import styled from 'styled-components'
import { when } from '../../../utils/mixin'
import { Icon } from '../../atoms/icon'
import { IconStroke } from '../../atoms/iconStroke'
import { Button, ButtonGroup } from '../../atoms/button'
// import { StatusIcon } from '../../molecules/status-icon'
import { Color, Size } from '../../../constants/app.constant'
// import history from '../../utils/history'
import useGetState from '../../../hooks/use-get-state'
// import { Inquiry } from '../../../interfaces/inquiry'
import { dispAge, calcAge } from '../report/utils'
import { Inquiry, InquiryAnswer } from '../../../interfaces/inquiry'
import { Form } from 'react-final-form'
import { putInquiry } from '../../../actions/inquiry.action'
import TextAreaFieldItem from '../../molecules/text-field/textarea-field'
import {
  composeValidators,
  required,
  // alphabeticAndNumeric,
} from '../../../utils/validator'
import { useDispatch } from 'redux-react-hook'

// const { useState, useEffect } = React
const { useEffect } = React
export default () => {
  const dispatch = useDispatch()
  const {
    state: {
      auth,
      patient,
      inquiry: { details },
    },
  } = useGetState()

  useEffect(
    () => {
      console.log('inquiry_detail/contents')
      //  if (details)
      //    setLocalLogs(details)
    },
    [details]
  )
  console.log(details)
  // console.log(localLogs);
  const inquiry: Inquiry = details
  const inquiryAnswers: InquiryAnswer[] = inquiry
    ? inquiry.answers
      ? inquiry.answers.sort(
          (x: InquiryAnswer, y: InquiryAnswer) =>
            new Date(y.createdAt).getTime() + new Date(x.createdAt).getTime()
        )
      : null
    : null

  const onSubmit = async (formValues: any) => {
    console.log('contents')
    console.log(formValues)
    const payload = {
      ...formValues,
      jwtToken: auth.user.idToken.jwtToken,
      inquiry: inquiry,
    }
    console.log(payload)
    dispatch(putInquiry(payload))
  }

  return (
    <Wrapper>
      <PageContents>
      <PageTitle>
          <PageTitleName>お問い合わせ詳細</PageTitleName>
        </PageTitle>
        <UserDetail>
          <Icon.User size={`${Size.XLARGE}px`} color={Color.DARK_GRAY} />
          <UserName>
            {patient.username}
            さん
          </UserName>
          <Age>{dispAge(calcAge(patient.birthdayYmd))}</Age>
          {/*
          <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
              <Button onClick={() => history.push(`/inquiry_form/`)}>新規お問い合わせ</Button>
          </ButtonGroup>
          */}
        </UserDetail>
        <UserQuestion>
          <DateDiv>
            {inquiry ? DateFns.format(inquiry.updatedAt, 'MM月DD日') : null}
          </DateDiv>
          <TimeDiv>
            {inquiry ? DateFns.format(inquiry.createdAt, 'HH:mm') : null}
          </TimeDiv>
          <InquiryNumber>
            お問い合わせNo. {inquiry ? inquiry.inquiryNumber : null}
          </InquiryNumber>
          <Question>{inquiry ? inquiry.question : null}</Question>
        </UserQuestion>
        <hr />
        <TrainingListWrapper>
          {inquiryAnswers
            ? inquiryAnswers &&
              inquiryAnswers.map((v: InquiryAnswer, index: number) => (
                <TrainingListItem key={index}>
                  {v.role === 'operator' ? (
                    <IconStroke.QAoperator
                      size={`${Size.XLARGE}px`}
                      color={Color.STRONG_RED}
                    />
                  ) : (
                    <IconStroke.QApatient
                      size={`${Size.XLARGE}px`}
                      color={Color.LIGHT_GRAY}
                    />
                  )}
                  <DateDiv>
                    {v.createdAt
                      ? DateFns.format(v.createdAt, 'MM月DD日')
                      : null}
                  </DateDiv>
                  <TimeDiv>
                    {v.createdAt ? DateFns.format(v.createdAt, 'HH:mm') : null}
                  </TimeDiv>
                  {/*{v.userId}*/}
                  <InquiryNumber>
                    {v.username ? v.username : null}
                  </InquiryNumber>
                  <Question>{v.answer}</Question>
                </TrainingListItem>
              ))
            : null}
        </TrainingListWrapper>

        <FormWrapper>
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {}
              errors.answer = composeValidators(
                required('返答を入力してください')
              )(values.answer)
              return errors
            }}
            initialValues={{
              userId: auth.user.idToken.payload['custom:userId'],
              username: patient.username,
              role: 'patient',
              createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <FieldSet>
                  <TextAreaFieldItem
                    name="answer"
                    type="textarea"
                    label="返答内容"
                    placeholder="返答内容を入力してください"
                    vertical
                    required={true}
                  />
                </FieldSet>
                <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
                  <Button primary>送信</Button>
                </ButtonGroup>
              </form>
            )}
          />
        </FormWrapper>
      </PageContents>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const PageContents = styled.div``
const PageTitle = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const PageTitleName = styled.div`
  font-size: ${Size.LARGE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const UserDetail = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const UserName = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const Age = styled.div`
  font-size: ${Size.BASE}px;
`

const UserQuestion = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px;
  background: ${Color.BG_GRADIENT_0};
  cursor: pointer;
`

const TrainingListWrapper = styled.div`
  margin: 8px 0;
  display: flex;
  flex-direction: column;
`
const TrainingListItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 12px;
  background: ${Color.BG_GRADIENT_0};
  cursor: pointer;
`

const FormWrapper = styled.div`
  position: relative;
  padding: 50px 30px 0;
`
const FieldSet = styled.div<{
  vertical?: boolean
}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  padding: 0 30px;
  div {
    width: 100%;
  }
  ${when('vertical')(`
    flex-direction: column;
    align-items: start;
  `)};
`

const DateDiv = styled.div`
   {
    padding: 0 0 0 5px;
    width: 80px;
    height: 27px;
    font-family: HiraginoSans-W3;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.75;
    letter-spacing: -0.36px;
    text-align: left;
    color: #5a5a5a;
  }

  .text-style-1 {
    font-size: 11px;
    letter-spacing: -0.26px;
  }
`

const TimeDiv = styled.div`
   {
    padding: 5px 0 0 0;
    width: 48px;
    height: 24px;
    font-family: HiraginoSans-W3;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.75;
    letter-spacing: -0.26px;
    text-align: left;
    color: #5a5a5a;
  }
`

const InquiryNumber = styled.div`
   {
    padding: 5px 0px 0px 10px;
    width: 199px;
    height: 24px;
    font-family: HiraginoSans-W3;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.75;
    letter-spacing: -0.26px;
    text-align: left;
    color: #5a5a5a;
  }
`
const Question = styled.div`
   {
    width: 343px;
    height: 23px;
    font-family: HiraginoSans-W3;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: -0.29px;
    text-align: left;
    color: #282828;
  }
`



// WEBPACK FOOTER //
// ./src/components/pages/inquiry_detail/contents.tsx